<mat-sidenav-container fullscreen>
    <mat-sidenav-content>
        <app-backheader></app-backheader>
        <div class="col-center col s12 mt-12" style="margin-top: 6vh;margin-bottom:8vh">

            <div class="market-page-inne">
                <div class="row">
                    <div class="col-lg-8 mobp0">
                        <div class="main-match-detail">
                            <div class="sk_teambettingsection matchodds ng-star-inserted">
                                <div class="sk_bettinginner">
                                    <div class="sk_betting-con-wrap" style="position: unset;">
                                        <button type="button" class="sk_bettingbtnfull">
                                            <div class="sk_bettingtileleft">
                                                <div class="sk_bettingtileleft">
                                                    <div class="sk_betitle_div ng-star-inserted"><span
                                                            class="sk_betitle "></span>{{ContestList.eventName}}<span
                                                            class="sk_bg-cross"></span></div>

                                                </div>

                                            </div>
                                            <span class="sk_matchedview">
                                                <div class="sk_matchedview-title ng-star-inserted">
                                                    <span>{{ContestList.openDate | date: 'dd/MM/yyyy'}}
                                                    </span>| <span>{{ContestList.openDate | date: 'hh:mm a'}}</span>
                                                </div>
                                            </span>
                                        </button>


                                        <div class="sk_match-detailtable" style="height: auto;">
                                            <div class="sk_match-detail-wrap">
                                                <div class="sk_match-detail-body"
                                                    style="padding: 5px 5px; margin:0px 12px;">
                                                    <div class="sk_match-detail-row ">
                                                        <div class="sk_match-body-col d-flex row">
                                                            <div *ngIf="!Teamlistshow" class="player-photo-list-grid">
                                                                <!-- <div class="player-photo-list"
                                                                    *ngFor="let item of ContestList?.marketBook?.runners">
                                                                    <div
                                                                        class="team-list-con border_around tournament-team-left  boder-bg">
                                                                        <figure class="me-1"><img
                                                                                src="https://sportsfly.cbsistatic.com/bundles/sportsmediacss/images/player/headshot-default.png"
                                                                                alt=""></figure>
                                                                        <div class="player-con">
                                                                            <h4>{{item?.runnerName}}</h4>
                                                                            <div class="player-btn-boll"><a
                                                                                    class="thm-but">Run</a><span
                                                                                    style="margin-left: 2px;">
                                                                                    {{item?.runs}}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> -->

                                                                <div class="player-photo-list"
                                                                    *ngFor="let item of ContestList?.marketBook?.runners;let i = index">

                                                                    <div class="team-list-con border_around  box-p"
                                                                        [ngClass]="{
                                                                        'tournament-team-left': i % 2 === 0,
                                                                        'tournament-team-right justify-content-end text-end ': i % 2 === 1,
                                                                        'blue-boder-bg': isUserSelected(item.selectionId),
                                                                        'green-boder-bg': isComputerSelected(item.selectionId)
                                                                     }" (click)="selectPlayer(item)">
                                                                        <div *ngIf=" i % 2 === 0" class="icon-s">
                                                                            <figure>
                                                                                <img
                                                                                    src="../../assets/images/icon/1193274.png">
                                                                            </figure>

                                                                            <div class="player-con">
                                                                                <div class="name"
                                                                                    style="text-align: start;">{{
                                                                                    item.runnerName }}
                                                                                </div>
                                                                                <div class="player-btn-boll">
                                                                                    <a class="thm-but">Run</a>
                                                                                    <span
                                                                                        style="margin-left: 2px;">{{item.runs}}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div *ngIf="i % 2 === 1" class="icon-s">


                                                                            <div class="player-con">
                                                                                <div class="name-c"
                                                                                    style="text-align: start;">{{
                                                                                    item.runnerName }}
                                                                                </div>
                                                                                <div class="player-btn-boll">
                                                                                    <a class="thm-but">Run</a>
                                                                                    <span
                                                                                        style="margin-left: 2px;">{{item.runs}}</span>
                                                                                </div>
                                                                            </div>
                                                                            <figure>
                                                                                <img
                                                                                    src="../../assets/images/icon/1193274.png">
                                                                            </figure>
                                                                        </div>

                                                                    </div>
                                                                </div>


                                                            </div>

                                                            <div *ngIf="Teamlistshow" class="row">
                                                                <div class="col-6 Team-name List-player">
                                                                    <span class="team">User Team List</span>
                                                                    <div class="player-photo-list "
                                                                        *ngFor="let item of userSelectedList">
                                                                        <div
                                                                            class="team-list-con border_around tournament-team-left  blue-boder-bg box-p">
                                                                            <figure><img
                                                                                    src="../../assets/images/icon/1193274.png">
                                                                            </figure>
                                                                            <div class="player-con">
                                                                                <div class="name">{{ item.runnerName }}
                                                                                </div>
                                                                                <div class="player-btn-boll"><a
                                                                                        class="thm-but">Run</a><span
                                                                                        style="margin-left: 2px;">
                                                                                        {{item?.runs}}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div class="col-6 Team-name List-player">
                                                                    <span class="team">Computer Team List</span>
                                                                    <div class="player-photo-list "
                                                                        *ngFor="let item of computerSelectedList">
                                                                        <div
                                                                            class="team-list-con border_around tournament-team-right justify-content-end text-end green-boder-bg box-p">

                                                                            <div class="player-con">
                                                                                <div class="name-c">{{ item.runnerName
                                                                                    }}
                                                                                </div>
                                                                                <div class="player-btn-boll"><a
                                                                                        class="thm-but">Run</a><span
                                                                                        style="margin-left: 2px;">
                                                                                        {{item?.runs}}</span>
                                                                                </div>
                                                                            </div>
                                                                            <figure><img
                                                                                    src="../../assets/images/icon/1193274.png">
                                                                            </figure>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="sk_match-body-col"
                                                    *ngIf="userSelectedList.length + computerSelectedList.length  === ContestList?.marketBook?.runners.length && showbtn">
                                                    <button class="footer-c" (click)="SaveTeam()">Save Team</button>
                                                    <button class="footer-c" (click)="clearteam()">Clear Team</button>
                                                </div>

                                                <div *ngIf="Teamlistshow" class="place-btn-s"
                                                   >
                                                    <input type="number" class="amount-input" placeholder="Enter amount"
                                                        [(ngModel)]="amount" />
                                                    <div  class="center-box">
                                                        <button class="place-btn" (click)="SaveBet()">
                                                            Place Bet
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4" style="margin-top: 1px;">
                        <div class="matchdetailsidebar">
                            <div class="sk_md-sidebar">
                                <div class="sk_widget">
                                    <div class="sk_open-bet">
                                        <div class="widgettitle">
                                            <h3 class="sk_opnbet-title">Open Bets</h3>
                                        </div>
                                        <div class="sk_open-bet-body">
                                            <div class="sk_open-bet-content">

                                                <div class="table-responsive openbet-table-wrap mt-2">
                                                    <table class="openbet-table table">
                                                        <thead>
                                                            <tr>
                                                                <th>Nation</th>
                                                                <th>Odds</th>
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <!--  -->
                                                            <tr class="ng-star-inserted" *ngIf="BetList.length === 0">
                                                                <td colspan="6">
                                                                    <div class="nodata font-weight-bold">No Data
                                                                        Found!</div>
                                                                </td>
                                                            </tr>
                                                            <tr *ngFor="let item of BetList">
                                                                <td>{{item.eventName}}</td>
                                                                <td>{{item.selectionName}}</td>
                                                                <td>{{item.stake}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #optionmodal>
<div class="modal-body ndsd">

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Who will choose first?</h5>
            </div>
            <div class="notesd">
                <div>
                Note*
                </div>
                <div>
                    If user choice first then computer will get bonus amount :{{computerPoint}} <br/>
                    If computer choice first then user will get bonus amount :{{userPoint}}
                </div>
            </div>

            <div class="modal-body text-center matchpopbody">
                <div class="modelcontentexposer">

                    <div class="d-flex justify-content-center gap-3">

                        <button class="btn back px-4 py-2" (click)="selectFirst('user')">
                            User
                        </button>


                        <button class="btn lay px-4 py-2" (click)="selectFirst('computer')">
                            Computer
                        </button>
                    </div>

                </div>
            </div>


            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-outline-danger" (click)="modaloption.hide()" data-bs-dismiss="modal">
                    Close
                </button>
            </div>

</div>
</ng-template>
